import React, { useEffect, useState } from "react"
import DPTextBoxforgrid from "framework/components/DPTextBoxforgrid";
import { Button, Col, Row } from "reactstrap";
import { Numeric, Text } from "framework/validators/TextValidation";
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic";


const ProductSupplierFreeQty = ({ freeQtyList, setFreeQtyList, Disabled, menuCode }) => {

    const onRowChange = (index, field, value) => {
        const updatedList = [...freeQtyList];
        updatedList[index][field] = value;
        setFreeQtyList(updatedList);
    }

    const handleRowChange = (index, row) => {
        const updatedList = [...freeQtyList];
        updatedList[index] = row
        setFreeQtyList(updatedList);
    }




    const onRowDelete = (index) => {
        const updatedList = [...freeQtyList];
        updatedList.splice(index, 1);

        //if list is empty, add a new row
        if (updatedList.length === 0) {
            updatedList.push({ supplier: "", supplierName: "", supplierDisable: false, qtyFrom: 0, qtyTo: 0, freeQty: 0 });
        }

        setFreeQtyList(updatedList);
    }

    const onRowAdd = () => {

        //check if there is any empty row in the list
        const emptyRow = freeQtyList.find((item) => item.qtyFrom === 0 || item.qtyTo === 0 || item.freeQty === 0);
        if (emptyRow) {
            return;
        }

        //check if the last row is filled
        const lastRow = freeQtyList[freeQtyList.length - 1];
        if (lastRow.qtyFrom === 0 || lastRow.qtyTo === 0 || lastRow.freeQty === 0) {
            return;
        }

        //add a new row to the list
        const newRow = { qtyFrom: 0, qtyTo: 0, freeQty: 0 };
        setFreeQtyList((prevSizes) => [...prevSizes, newRow]);

    }



    return (
        <React.Fragment>
            <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                    <table style={{ fontSize: "11px" }} id={"PriceDet"}>
                        <thead className="table-light">
                            <tr>
                                <th style={{ width: "20%" }}>Supplier</th>
                                <th style={{ width: "5%" }}></th>
                                <th style={{ width: "20%" }}>Name</th>
                                <th style={{ width: "20%" }}>QTY from</th>
                                <th style={{ width: "20%" }}>QTY to</th>
                                <th style={{ width: "20%" }}>Free Qty</th>
                            </tr>
                        </thead>
                        <tbody disabled={true}>
                            {freeQtyList.map((item, index) => (
                                <TableRow
                                    key={index}
                                    item={item}
                                    index={index}
                                    onRowChange={onRowChange}
                                    onRowDelete={onRowDelete}
                                    handleRowChange={handleRowChange}
                                    Disabled={Disabled}
                                    menuCode={menuCode}
                                />
                            ))}
                        </tbody>
                    </table>
                </Col>



            </Row>
            <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                    <Button
                        id="addBtn"
                        color="success"
                        className="btn btn-primary"
                        size="sm"
                        disabled={Disabled}
                        onClick={() => {
                            onRowAdd();
                        }}
                    >
                        Add
                    </Button>
                </Col>
            </Row>


        </React.Fragment>
    );

}


const TableRow = ({ item, index, onRowChange, onRowDelete, handleRowChange, Disabled, menuCode }) => {

    const ApiURL = window.Links.ApiURL
    const [modal_xlargeSup, setModal_xlargeSup] = useState(false);
    const tog_xlargeSup = () => setModal_xlargeSup(!modal_xlargeSup);


    async function SupplierCodeSearch(index, value) {
        if (value === "") {
            return;
        }
        let cuurentRow = item;
        const authToken = localStorage.getItem("authToken");

        try {
            const response = await fetch(`${ApiURL}Supplier/Grid/${value}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${authToken}`
                },
            });

            const responseData = await response.json();

            if (responseData.success) {
                const newArray = responseData.data[0];

                cuurentRow.supplierName = newArray.name;
                cuurentRow.supplier = newArray.code;
                cuurentRow.supplierDisable = true;

            } else {
                cuurentRow.supplierName = "";
                cuurentRow.supplier = "";
                cuurentRow.supplierDisable = false;
            }
        } catch (error) {
            console.error("Error occurred while fetching supplier data:", error);

            cuurentRow.supplierName = "";
            cuurentRow.supplier = "";
            cuurentRow.supplierDisable = false;

        } finally {
            handleRowChange(index, cuurentRow);
        }
    }


    const defaultSorted = [
        {
            dataField: "id",
            order: "asc",
        },
    ]


    const Hed_SelectRowSearch = (e, row, isSelect, rowIndex) => {
        tog_xlargeSup()
        SupplierCodeSearch(index, row.SM_CODE)
    }


    return (
        <tr key={index}>
            <td>
                <DPTextBoxforgrid
                    id={"supplier" + index}
                    value={item.supplier}
                    onChange={(e) => {
                        var supplier = Text(e.target, 30, true, true, 'any', false)
                        onRowChange(index, "supplier", supplier);
                    }}
                    onBlur={(e) => {

                        SupplierCodeSearch(index, e.target.value)

                    }}
                    disabled={Disabled || item.supplierDisable}
                />
            </td>
            <td>
                <Button
                    id="delBtn"
                    color="success"
                    className="btn btn-success"
                    size="sm"
                    disabled={Disabled || item.supplierDisable}
                    onClick={tog_xlargeSup}
                >
                    <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                    ></i>
                </Button>
            </td>
            <td>
                <DPTextBoxforgrid
                    id={"supplierName" + index}
                    value={item.supplierName}
                    disabled={true}
                />
            </td>
            <td>
                <DPTextBoxforgrid
                    id={"qtyFrom" + index}
                    textAlign={"right"}
                    value={item.qtyFrom}
                    onChange={(e) => {

                        var qtyFrom = Numeric(e.target, 18, 4, false);
                        onRowChange(index, "qtyFrom", qtyFrom);
                    }}
                    onBlur={(e) => {

                        if (e.target.value === "") {
                            onRowChange(index, "qtyFrom", 0);
                        }


                    }}


                    disabled={Disabled}
                />
            </td>
            <td>
                <DPTextBoxforgrid
                    id={"qtyTo" + index}
                    textAlign={"right"}
                    value={item.qtyTo}
                    onChange={(e) => {
                        var qtyTo = Numeric(e.target, 18, 4, false);
                        onRowChange(index, "qtyTo", qtyTo);
                    }}
                    onBlur={(e) => {
                        if (e.target.value === "") {
                            onRowChange(index, "qtyTo", 0);
                        }
                    }}
                    disabled={Disabled}
                />
            </td>
            <td>
                <DPTextBoxforgrid
                    id={"freeQty" + index}
                    textAlign={"right"}
                    value={item.freeQty}
                    onChange={(e) => {
                        var freeQty = Numeric(e.target, 18, 4, false);
                        onRowChange(index, "freeQty", freeQty);
                    }}
                    onBlur={(e) => {
                        if (e.target.value === "") {
                            onRowChange(index, "freeQty", 0);
                        }
                    }}
                    disabled={Disabled}
                />
            </td>
            <td>
                <Button
                    id="delBtn"
                    color="danger"
                    className="btn btn-danger"
                    size="sm"
                    disabled={Disabled}
                    onClick={() => {
                        onRowDelete(index);
                    }}
                >
                    <i
                        className="mdi mdi-delete"
                        style={{ fontSize: "12px" }}
                    ></i>
                </Button>
            </td>
            <DPSearchBoxDynamic
                searchData={[]}
                columns={[]}
                defaultSorted={defaultSorted}
                mainTitle="Supplier Search"
                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                isOpen={modal_xlargeSup}
                toggle={tog_xlargeSup}
                getSelect={Hed_SelectRowSearch}
                APIURL={ApiURL}
                URLPath={"SUPPLIER"}
                MenuCode={menuCode}
                KeyVal={'PRO'}
                searchBy={'SM_CODE'}
                FilterStr={'a'}
            />
        </tr>
    )

}



export default ProductSupplierFreeQty;